import React, { useState } from 'react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, Button } from '@chakra-ui/react';
import { PageContainer } from '../../layouts/PageContainer';
import { PageHeader } from '../../layouts/PageHeader';
import { Link } from 'react-router-dom';

const ApprovedRequest = () => {
    const [numRequests, setNumRequests] = useState(0);
    // Dummy Data (Hard Coded)
    const tableData = [
        { searcher: 'Rand Al Rabadi', requestDate: '2024-01-28', status: 'Approved' },
        { searcher: 'Russ Greer', requestDate: '2024-02-02', status: 'Approved' },
        { searcher: 'Adam Hansen', requestDate: '2024-02-03', status: 'Pending' },
    ];

    return (
        <PageContainer>
            <PageHeader title="Data Access Requests" color="#1C4342"></PageHeader>
            <Box px={4} py={8}>
                <Text fontSize={"2.5rem"} color="#1C4342">
                    Data Access Requests
                </Text>
                <Text fontSize={"1.2rem"} color="#1C4342">
                    Pending Data Access Requests:
                    <Text fontSize={"1.2rem"} color="#1C4342">
                        • You have {numRequests} number of requests to review:
                    </Text>
                </Text>

                <Table variant="simple">
                    <Thead>
                        <Tr bg="#1C4342">
                            <Th color="white" borderRight="1px solid white">Searcher</Th>
                            <Th color="white" borderRight="1px solid white">Request Date</Th>
                            <Th color="white">Approval Status</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {tableData.map((data, index) => (
                            <Tr key={index}>
                                <Td borderRight="1px solid #CBD5E0">{data.searcher}</Td>
                                <Td borderRight="1px solid #CBD5E0">{data.requestDate}</Td>
                                <Td>
                                    {data.status === 'Pending' ? (
                                        <Link to="/pending-requests">
                                            <Button size="sm" bg="#1C4342" rounded={4} color={'white'}>{data.status}</Button>
                                        </Link>
                                    ) : (
                                        data.status
                                    )}
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>
        </PageContainer>
    );
};

export default ApprovedRequest;
